import { Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const NotFound = (props: any) => {
  const navigate = useNavigate();

  const goBackHandler = () => {
    navigate("/");
  };

  return (
    <>
      <Typography
        style={{ textAlign: "center", marginTop: "100px", fontSize: "70px" }}
      >
        Not Found
      </Typography>
      <Grid2
        sx={{
          alignItems: "center",
          marginTop: "10px",
          textAlign: "center",
        }}
      >
        <Typography variant="h4">Sorry, This page doesn't exit</Typography>
        <br />
        <Typography
          variant="h4"
          sx={{
            color: " #0c5f99",
            textDecoration: "underline",
            cursor: "pointer",
            display: "inline-block",
          }}
          onClick={goBackHandler}
        >
          Click here to go Back
        </Typography>
      </Grid2>
    </>
  );
};

export default NotFound;
